import { Route, Routes } from 'react-router'
import { InternationalStepsLayout } from 'pages/settings/pages/compliance/pages/international/layout/InternationalStepsLayout'
import { BusinessInfo } from 'pages/settings/pages/compliance/pages/international/ui/BusinessInfo/BusinessInfo'
import { BusinessAddress } from 'pages/settings/pages/compliance/pages/international/ui/BusinessAddress/BusinessAddress'
import { FinalDetails } from 'pages/settings/pages/compliance/pages/international/ui/FinalDetails/FinalDetails'
import { ContactInfo } from 'pages/settings/pages/compliance/pages/international/ui/ContactInfo/ui/ContactInfo'
import { InternationalRoutes } from './type'

export const InternationalStepsRouter = () => {
  return (
    <Routes>
      <Route element={<InternationalStepsLayout />}>
        <Route path={InternationalRoutes.businessInfo} element={<BusinessInfo />} />
        <Route path={InternationalRoutes.businessAddress} element={<BusinessAddress />} />
        <Route path={InternationalRoutes.contactInfo} element={<ContactInfo />} />
        <Route path={InternationalRoutes.finalDetails} element={<FinalDetails />} />
      </Route>
    </Routes>
  )
}
